import { jsx as _jsx } from "react/jsx-runtime";
import TopicPageAppBarMobile from "../TopicPageAppBarMobile";
import TopicPageViewsLabelMenu from "./TopicPageViewsLabelMenu";
const TopicPageViewsLabelAppBarMobile = (props)=>{
    const { label  } = props;
    return /*#__PURE__*/ _jsx(TopicPageAppBarMobile, {
        children: /*#__PURE__*/ _jsx(TopicPageViewsLabelMenu, {
            variant: "mobile",
            label: label
        })
    });
};
export default TopicPageViewsLabelAppBarMobile;
